module.exports = __webpack_public_path__ + "static/media/icon-approved-circular.9e969e34.svg";